import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { CookiesContext } from "../Context/CookiesContext";
import { 
    initializeCookieConsentAction,
    acceptAllCookiesAction,
    acceptNecessaryCookiesAction,
    manageCookieSettingsAction,
    saveCookiePreferencesAction
} from "../../../Actions/UIActions/Cookies";
import { _eventBus } from "../../../core/events/EventBus";
import { cookieTree } from "../../../Orchestrator/ConstantTree";

interface IManageCookieSettingsParams {
    showModal: boolean;
    cookieConsentGiven?: boolean;
}

interface ISaveCookiePreferencesParams {
    preferences: Record<string, boolean>;
    cookieConsentGiven: boolean;
}

export class CookiesInitStep extends StepFlow {
    get stepName() { return "CookiesInit_Step"; }

    async onEventSetup(): Promise<void> {
        // Accept All Cookies Event
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: cookieTree.Consent.Accept.All,
                handler: async () => {
                    await acceptAllCookiesAction.execute();
                }
            })
        );

        // Accept Necessary Cookies Event
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: cookieTree.Consent.Accept.Necessary,
                handler: async () => {
                    await acceptNecessaryCookiesAction.execute();
                }
            })
        );

        // Manage Cookie Settings Open Event
        this.registerEventSubscription(
            _eventBus.on<IManageCookieSettingsParams, void>({
                eventName: cookieTree.Consent.Manage.Settings.Open,
                handler: async ({ data }) => {
                    manageCookieSettingsAction.setParams(data!);
                    await manageCookieSettingsAction.execute();
                }
            })
        );

        // Manage Cookie Settings Close Event
        this.registerEventSubscription(
            _eventBus.on<IManageCookieSettingsParams, void>({
                eventName: cookieTree.Consent.Manage.Settings.Close,
                handler: async ({ data }) => {
                    manageCookieSettingsAction.setParams(data!);
                    await manageCookieSettingsAction.execute();
                }
            })
        );

        // Save Cookie Preferences Event
        this.registerEventSubscription(
            _eventBus.on<ISaveCookiePreferencesParams, void>({
                eventName: cookieTree.Consent.Save.Preferences,
                handler: async ({ data }) => {
                    saveCookiePreferencesAction.setParams(data!);
                    await saveCookiePreferencesAction.execute();
                }
            })
        );
    }

    async onExecute(): Promise<void> {
        this.setCtx("cookiesContext", CookiesContext);
        
        // Initialize cookie consent using the action
        await initializeCookieConsentAction.execute();
        
        console.log("Cookies Initialize.....")
    }

}

export const CookiesInitStepDeclaration = new StepDefinition({
    stepName: "CookiesInit_Step",
    stepClass: CookiesInitStep
});